import trackClevertapEvents from "@/utils/trackClevertapEvents";
import { Arrow } from "@monsterindia/global-ui-components";
import { useRouter } from "next/navigation";
import React from "react";

import { SETTINGS_TABS } from "../../contents/constants";

type LeftSideBarProps = {
  isMobile: boolean;
  activeTab: string;
  setActiveTab: React.Dispatch<React.SetStateAction<string>>;
  setActiveLabel: React.Dispatch<React.SetStateAction<string>>;
  currentQueryParams: URLSearchParams;
  showAutoApply: boolean;
};
const LeftSideBar = ({
  isMobile,
  activeTab,
  setActiveTab,
  setActiveLabel,
  currentQueryParams,
  showAutoApply,
}: LeftSideBarProps) => {
  const router = useRouter();
  const handleTabClick = (tab: any) => {
    if (isMobile) {
      setActiveLabel(tab?.label || "");
    }
    setActiveTab(tab?.name || "");
    trackClevertapEvents.eventPush("Settings Clicked", {
      sectionName: tab?.name,
    });
    currentQueryParams.set("activeTab", tab?.name);
    router.push(`?${currentQueryParams.toString()}`);
  };

  const visibleTabs = Object.values(SETTINGS_TABS).filter((tab) => {
    if (tab.name === SETTINGS_TABS.AUTO_APPLY.name) {
      return showAutoApply;
    }

    return true;
  });

  return (
    <div className="md:w-1/4">
      <div className="settings-navigation-container">
        {visibleTabs?.map((tab) => (
          <div
            className={`align-center flex cursor-pointer justify-between ${!isMobile && "border-b border-[#d2d1d6]"} p-3 ${
              activeTab === tab?.name && !isMobile ? "bg-[#f7f2fa]" : ""
            }`}
            key={tab?.name || ""}
            onClick={() => handleTabClick(tab)}
          >
            <div className="self-center">
              <p
                className={`${isMobile ? "text-base font-medium" : "text-sm"}`}
              >
                {tab?.label || ""}
              </p>
              {isMobile && (
                <span className="text-content-secondary text-xs">
                  {tab?.description || ""}
                </span>
              )}
            </div>
            <div>
              <Arrow
                height={32}
                width={32}
                className="min-w-8 rotate-[-90deg] transform text-black"
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LeftSideBar;
